export const SET_ASK_FOR_PHONE = 'SET_ASK_FOR_PHONE'
export const SET_ACTION_DATA = 'SET_ACTION_DATA'
